import SideBarLayout from "../SideBarLayout/SideBarLayout";

const AdminLayout = ({ children }) => {
  return (
    <div className="container-fluid">
      <div id="layout-wrapper">
        {/* <HeaderLayout /> */}
        <SideBarLayout />

        <div className="main-content">
          <div className="page-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
